module.exports = __webpack_public_path__ + "img/online_school_and_classroom_activities.7a4f3b73.svg";